import React, { useEffect } from 'react';
import PageTitle from './PageTitle';
import Spacer from './Spacer';
import { recordStudyComplete } from '../utils/studyTimingApi';
import './DemographicsPage.styles.css';

const DEFAULT_COMPLETION_CODE = 'D8AB65A277';
const COMPLETION_CODE = (process.env.REACT_APP_COMPLETION_CODE || DEFAULT_COMPLETION_CODE).trim();

type StudyCompletionThankYouProps = {
  participantId: string | null;
};

const StudyCompletionThankYou: React.FC<StudyCompletionThankYouProps> = ({ participantId }) => {
  useEffect(() => {
    recordStudyComplete(participantId);
  }, [participantId]);

  return (
    <div className="demographics-bg">
      <div className="demographics-card fade-in">
        <PageTitle title="Thank You!" />
        <Spacer />
        <div className="demographics-thankyou" style={{ fontSize: 20, marginBottom: 18 }}>
          Thank you for participating in our study!
          <br />
          We appreciate your time and effort.
        </div>
        <div
          style={{
            background: '#e3f2fd',
            border: '1.5px solid #1976d2',
            borderRadius: 12,
            padding: '22px 18px',
            margin: '0 auto 18px auto',
            maxWidth: 380,
            textAlign: 'center',
            boxShadow: '0 2px 12px rgba(25, 118, 210, 0.08)',
            fontSize: 18,
            color: '#1976d2',
            fontWeight: 600,
          }}
        >
          <div style={{ marginBottom: 8 }}>
            To complete your task, please copy and paste this code:
          </div>
          <div
            style={{
              fontSize: 26,
              fontWeight: 800,
              letterSpacing: 2,
              color: '#1565c0',
              background: '#fff',
              borderRadius: 8,
              padding: '10px 0',
              margin: '0 auto',
              width: '100%',
              boxShadow: '0 1px 4px rgba(25, 118, 210, 0.06)',
            }}
          >
            {COMPLETION_CODE}
          </div>
        </div>
        <div style={{ fontSize: 15, color: '#888', marginTop: 8, textAlign: 'center' }}>
          Return to the study platform and enter this code to finish. You may close this window when
          you are done.
        </div>
      </div>
    </div>
  );
};

export default StudyCompletionThankYou;
